export default "__VITE_ASSET__LphhLScmzwPqWwTyAbd7ig__";